import { useNotificationsStore } from "@/store/modules/socio-store/notification";

export const showSuccessNotification = (message) =>
  useNotificationsStore().showSuccessNotification(message);
export const showWarningNotification = (message, options) =>
  useNotificationsStore().showWarningNotification(message, options);
export const showErrorNotification = (message, options) =>
  useNotificationsStore().showErrorNotification(message, options);
export const dismissNotification = (key) =>
  useNotificationsStore().dismissNotification(key);
